import { isDate } from 'lodash';
import { getStatusDescriptionFromStatusValue } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';

const ctInitialQuotesOptions = (ctInitialQuotes, selectedValues = []) => {
    const quoteOptions = ctInitialQuotes.map(ctInitialQuote => ({ id: ctInitialQuote, label: ctInitialQuote, disabled: selectedValues.includes(ctInitialQuote) }));
    return [...quoteOptions]
}

export default function dealDetailsColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const { dealDetailRow = [], ctInitialQuotes = [], selectedCTInitialQuote = "", dealStatus } = config.data;



    dealDetailRow.forEach(deal => {
        let row = [];
        const rowId = deal.dealId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;
            let isDisabled = false;

            let columnValue = null;

            if (columnDataType === "string") {
                if (columnId === "dealName") {
                    columnValue = deal.dealId || "";
                }
                else if (columnId === "company") {
                    columnValue = deal.company || "";
                }
                else if (columnId === "orgId") {
                    columnValue = deal.orgId || "";
                }
                else if (columnId === "revitalizeDeal") {
                    columnValue = deal.revitalizeDeal || "";
                }
                else if (columnId === "dealStartDate") {
                    columnValue = getDateWithSpecificFormat(deal.dealStartDate);
                }
                else if (columnId === "dealExpirationDate") {
                    columnValue = getDateWithSpecificFormat(deal.dealExpirationDate);
                }
                else if (columnId === "salesContactEmailAddress") {
                    columnValue = deal.salesContactEmailAddress || "";
                }
                else if (columnId === "dealType") {
                    //added deal type
                    columnValue = getStatusDescriptionFromStatusValue(deal.dealType) || "";
                }

            } else if (columnDataType === "multiselect") {
                if (columnId === "ctInitialQuote") {
                    const selectedValues = deal.ctInitialQuote ? (Array.isArray(deal.ctInitialQuote) ? deal.ctInitialQuote : deal.ctInitialQuote.split(',')) : [];
                    columnValue = { ...column.data };
                    columnValue.options = ctInitialQuotesOptions(ctInitialQuotes, selectedCTInitialQuote);
                    columnValue.defaultValue = selectedValues;
                    isDisabled = (dealStatus === "ACTIVE") ? false : true;
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabledCell: isDisabled,
                    clickHandler: (event) => config.bodyButtonsHandler(event, columnId)
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
